import 'css-chunksrc/client/scenes/projectPortfolioEdition/form/styles.scss';export default {
  "form": "_form_1svwv_1",
  "group": "_group_1svwv_5",
  "label": "_label_1svwv_9",
  "row": "_row_1svwv_15",
  "textInput": "_textInput_1svwv_23",
  "tag": "_tag_1svwv_27",
  "description": "_description_1svwv_31"
};